import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  IconButton,
  MenuItem,
  Select,
  Chip,
  FormControl,
  InputLabel,
  Stack,
  useMediaQuery,
} from '@mui/material';
import { Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
import { Role } from 'src/types/brand';
import { UserDash, UserProfile } from 'src/interfaces/user';
import { createOrganizationsWithRoles } from 'src/utils/Utils';
import { updateBrandsForUser, updateLocationForUser, editUserRoles } from 'src/config/firebaseConfig';
import LazyLoadedOrganizationGrid from './LazyLoadedOrganizationGrid';
import { selectClientType } from 'src/app/selectors/filterSelectors';



interface Organization {
    id: string;
    name: string;
    roles: Role[];
  }

interface OrganizationRoleManagerProps {
    activeTab: number;
    open: boolean;
    onClose: () => void;
    brands: any;
    security: any;
    selectedUser: UserProfile;
    locations: any;
    onSave: (selectedOrganizations: Organization[]) => void;
}

const OrganizationRoleManager: React.FC<OrganizationRoleManagerProps> = ({
  activeTab,
    brands,
    security,
  open,
  selectedUser,
  locations,
  onClose,
  onSave
}) => {
  console.log("security",security)
  let {sorgs, aorgs, publicRoles} = selectedUser ? createOrganizationsWithRoles(activeTab == 2? locations :brands, selectedUser,security ? security.roles : null,activeTab) : {}
  console.log("sorgs",sorgs)
  const [selectedOrganizations, setSelectedOrganizations] = useState(sorgs)
  const [availableOrganizations, setAvailableOrganizations] = useState(aorgs ?? [])
  const [selectedOrganizationId, setSelectedOrganizationId] = useState<string>('');
  const [selectedRoles, setSelectedRoles] = useState<Role[]>([]);
  const dialogRef = useRef<HTMLDivElement | null>(null);
  const [dialogWidth, setDialogWidth] = useState<number>(0);
  const clientType = useSelector(selectClientType);

  useEffect(() => {
    if (dialogRef.current) {
      setDialogWidth(dialogRef.current.offsetWidth);
    }
  }, [open]); 

  //const [currentUserExceptionRoles,setCurrentUserExceptionRoles] = useState({...selectedUser?.brands?.exceptions?.roles ?? {}})
  let currentUserClient = {}
  if(activeTab == 0){
    currentUserClient = (selectedUser?.brands ?? {}) 
  }else if(activeTab == 2){
    currentUserClient = (selectedUser?.locations ?? {})
  }else{
    currentUserClient = (selectedUser?.servicerApp ?? {})
  }
  console.log('selectedUser',selectedUser)
  
  

  const handleSave = () => {
    console.log("selectedOrganizations",selectedOrganizations)
    console.log("availableOrgsForSelection",availableOrganizations)
    


    console.log("save--", brands);
    //onSave(selectedOrganizations);
    onClose();
  };
  const handleAddOrganization = () => {
    const organization = availableOrganizations.find((org) => org.id === selectedOrganizationId);
    if (organization && selectedRoles.length > 0) {
      const newOrg = { ...organization, roles: selectedRoles };
      let data = { ...currentUserClient }; // Clone the object to avoid mutations
      //brands logic for internal users
      if(activeTab === 0 &&  currentUserClient.allBrands && selectedUser.userType == 'internal'){
        const brandsExceptions = { ...(data.exceptions?.brands || {}) };
        if (brandsExceptions[organization.id]) {
          delete brandsExceptions[organization.id];
        }
        console.log('brandsExceptions',brandsExceptions)
        data = {
          ...data,
          exceptions: {
            ...data.brands?.exceptions,
            brands: brandsExceptions,
          },
        };
        
        //locations logic for internal users
      }else if(activeTab === 2 &&  currentUserClient.allLocations && selectedUser.userType == 'internal'){
        const locationsExceptions = { ...(data.exceptions?.locations || {}) };
        if (locationsExceptions[organization.id]) {
          delete locationsExceptions[organization.id];
        }
        console.log('locationsExceptions',locationsExceptions)
        data = {
          ...data,
          exceptions: {
            ...data.locations?.exceptions,
            locations: locationsExceptions,
          },
        };
      }else if(activeTab === 0 &&  selectedUser.userType == 'external'){
       
        data.brandList = {
          ...data.brandList,
          [organization.id]: selectedRoles.reduce((acc, roleId) => {
            acc[roleId.id ?? "-"] = true;
            return acc;
          }, {}),
        };
         
        
      }else if(activeTab === 2 &&  selectedUser.userType == 'external'){
       
        data.locationList = {
          ...data.locationList,
          [organization.id]: selectedRoles.reduce((acc, roleId) => {
            acc[roleId.id ?? "-"] = true;
            return acc;
          }, {}),
        };
         
        
      }

      console.log("data",data)
      if(activeTab ==2){
        updateLocationForUser(selectedUser.id, data).then(res => console.log("=====",res))
      }else{
        updateBrandsForUser(selectedUser.id, data).then(res => console.log("=====",res))
      }
     
      
      setSelectedOrganizations([...selectedOrganizations, newOrg]);
      setSelectedOrganizationId('');
      setSelectedRoles([]);
    }
  };


  // const handleDeleteOrganization = (orgId: string) => {
  //   setSelectedOrganizations(selectedOrganizations.filter((org) => org.id !== orgId));
  //   const organization = selectedOrganizations.find((org) => org.id === orgId);
  //   availableOrganizations.push(organization)
  //   setAvailableOrganizations(availableOrganizations)
    
  // };

  const handleDeleteOrganization = (orgId: string) => {
    const organizationToRemove = selectedOrganizations.find((org) => org.id === orgId);
  
    if (!organizationToRemove) return;
  
    // Add back the deleted organization to the available list
    setAvailableOrganizations([...availableOrganizations, organizationToRemove]);
    setSelectedOrganizations(selectedOrganizations.filter((org) => org.id !== orgId));
  
    // Create a copy of the current user object to avoid direct mutation
    let updatedData = { ...currentUserClient };
  
    if (activeTab === 0 && selectedUser.userType === 'internal') {
      // Handle brands exceptions logic for internal users
      const exceptions = { ...(updatedData.exceptions?.brands || {}) };
      exceptions[orgId] = true;
  
      updatedData = {
        ...updatedData,
        exceptions: {
          ...updatedData.exceptions,
          brands: exceptions,
        },
      };
    } else if (activeTab === 0 && selectedUser.userType === 'external') {
      // Handle brand deletion for external users
      if (updatedData.brandList) {
        delete updatedData.brandList[orgId];
      }
    } else if (activeTab === 2 && selectedUser.userType === 'internal') {
      // Handle locations exceptions logic for internal users
      const exceptions = { ...(updatedData.exceptions?.locations || {}) };
      exceptions[orgId] = true;
  
      updatedData = {
        ...updatedData,
        exceptions: {
          ...updatedData.exceptions,
          locations: exceptions,
        },
      };
    }
    else if (activeTab === 2 && selectedUser.userType === 'external') {
      // Handle location deletion for external users
      if (updatedData.locationList) {
        delete updatedData.locationList[orgId];
      }
    }
    //Verify both above external scenarios)
  
    // Save the updated data back to Firebase
    if (activeTab === 2) {
      updateLocationForUser(selectedUser.id, updatedData)
        .then(() => console.log('Location updated successfully after deletion'))
        .catch((error) => console.error('Error updating location:', error));
    } else {
      updateBrandsForUser(selectedUser.id, updatedData)
        .then(() => console.log('Brands updated successfully after deletion'))
        .catch((error) => console.error('Error updating brands:', error));
    }
  };

  const handleRoleChange = async(orgId: string, roles: Role[], isNew = false) => {
    console.log("Updating roles for:", orgId, roles);
  
    const updatedOrgs = selectedOrganizations.map((org) =>
      org.id === orgId ? { ...org, roles } : org
    );
  
    setSelectedOrganizations(updatedOrgs);
  
    let updatedData = { ...currentUserClient };
  
    let newUserData;
    let brandsRoles = roles.reduce((acc, roleId) => {
      acc[roleId.id] = true;
      return acc;
    }, {});

    if (activeTab === 0 && selectedUser.userType === "internal") {
      newUserData = {
        brandCommonRoles: brandsRoles
      }

    } else if (activeTab === 0 && selectedUser.userType === "external") {

      if (updatedData.brandList) {
           newUserData = {
            brandList: {
             [orgId]: brandsRoles,
            }
          }
      }

    } else if (activeTab === 2 && selectedUser.userType === "internal") {
      newUserData = {
        locationCommonRoles: brandsRoles
      };
    } else if (activeTab === 2 && selectedUser.userType === "external") {

      if (updatedData.locationList) {
         newUserData = {
           locationList: {
             [orgId]: brandsRoles,
           }
         }
      }
    }
  
    console.log("Updated user data:", updatedData);
    console.log("NewUpdated user data:", newUserData);
    const uuId = selectedUser.id;
    const userType = selectedUser.userType;

    await editUserRoles(newUserData, uuId, userType, clientType);
  
  };



  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      
      <DialogTitle className="bg-gray-100 text-gray-800 font-semibold">
        Manage Organizations and Roles
      </DialogTitle>
      <DialogContent ref={dialogRef} className="space-y-6">
        {/* Selected Organizations */}
       
      
          <LazyLoadedOrganizationGrid
            selectedOrganizations={selectedOrganizations}
            publicRoles={publicRoles}
            handleRoleChange={handleRoleChange}
            handleDeleteOrganization={handleDeleteOrganization}
            selectedUser= {selectedUser}
            activeTab = {activeTab}
            currentUserClient={currentUserClient}
          />

        

        {/* Add Organization Section */}
        {availableOrganizations.length > 0 && (
          <div className="flex flex-col space-y-4 border-t pt-4">
            <h3 className="text-lg font-semibold">Add New Organization</h3>
            <FormControl fullWidth>
              <InputLabel>Select Organization</InputLabel>
              <Select
                value={selectedOrganizationId}
                onChange={(e) => setSelectedOrganizationId(e.target.value as string)}
                fullWidth
                className="bg-gray-50"
              >
                {availableOrganizations.map((org) => (
                  <MenuItem key={org.id} value={org.id}>
                    {org.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth disabled={!selectedOrganizationId}>
              <InputLabel>Select Roles</InputLabel>
              <Select
                multiple
                value={selectedRoles}
                onChange={(e) =>
                    handleRoleChange(
                      selectedOrganizationId,
                      (e.target.value as Role[]).map((role) => role), true
                    )
                  }
                renderValue={() => <div>Add/Remove</div>}
                fullWidth
                className="bg-gray-50"
              >
                {publicRoles.filter((frole) => !selectedRoles.some((srole) => srole.id === frole.id)).map((role) => (
                    <MenuItem key={role.id} value={role}>
                      {role.name}
                    </MenuItem>
                  ))}
              </Select>
              <div className="flex flex-wrap gap-2">
                    {selectedRoles.map((role) => (
                      <Chip key={role.id} label={role.name} onDelete={() => handleRoleChange(
                        selectedOrganizationId,
                        selectedRoles.filter((r) => r.id !== role.id), true
                      )} className="bg-orange-500 text-white" />
                    ))}
                  </div>
            </FormControl>
            <Button
              onClick={handleAddOrganization}
              variant="contained"
              color="primary"
              disabled={!selectedOrganizationId || selectedRoles.length === 0}
            >
              Add Organization
            </Button>
          </div>
        )}
      </DialogContent>
      <DialogActions className="bg-gray-100">
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrganizationRoleManager;
